import { Book, StatusEnum } from "../book/data-types"

export enum ChatSectionEnum {
	Cafe = 'cafe',
	Salon = 'salon',
	SalonComments = 'salon_comments'
}

export enum ChatEntityType {
    Club = "club",
    GeneralChat = "general_chat",
}


export type Notification = {
    id: number
    notification_type: string
    image: string

    book?: Book
    club_id?: number
    status_id?: StatusEnum

    who_initiated: {
        first_name: string
        last_name: string
        picture: string
        public_id: string
    }

    rating?: string

    is_read: boolean // is counted in the counter
    is_tapped: boolean // did user consult the notification

    creation_date: string // ISO date

    user_list?: {
        first_name: string
        last_name: string
        id: string
        join_date: string // ISO date
        picture?: string
    }[]
}

export type MessageUser = {
    id: number
    public_id: string
    first_name: string
    last_name: string
    picture?: string
    facebook_id: string
    language?: string
    badge?: {
        id: string
        image: string
    }
    current_club_status?: StatusEnum
}

export type MessageReply = {
    _id: string
    id: string
    date: string
    message: string
    user: MessageUser
}

export type Message = {
    "_id": string
    message: string
    images?: string[]
    frame_id?: string
    date: string
    user: MessageUser
    club_id: string
    status_id: StatusEnum
    reply_message?: MessageReply
    reply_target_id?: string
}

export type MessagesMeta = {
    last_read_date: string | null
    unread_count: number
    new_mentions: string[]
}

export type Post = {
    id: 9401,
    kind: "review" | "post"
    creation_date: string,
    likes: number,
    content: string,
    is_abused: boolean,
    club?: number, // club_id
    chat_id?: number // chat_id
    title?: string, // review title, if kind == review
    rating?: string,
    user: MessageUser,
    comment_amount: number,
    liked: boolean,
    updated_at?: string,
    last_comment?: {
        date: string
        user: {
            first_name: string
            last_name: string
            picture?: string
            public_id: string,
        }
    }
}
